import * as types from '../constants/ActionTypes';

const initialState = {
	list: {},
	error: null,
	isFetching: false,
};

export default function corporationFeeds(state = initialState, action) {
	switch (action.type) {

		case types.REQUEST_CORP_FEEDS_LIST:
			return {
				...state,
				list: {},
				isFetching: true,
				error: null,
			};

		case types.RECEIVE_CORP_FEEDS_LIST:
			return {
				...state,
				list: action.corporationFeeds,
				isFetching: false,
			};

		case types.RECEIVE_CORP_FEEDS_LIST_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.error,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/corporation-feeds.js